<template>
  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">Metrics</span>
    </div>
    <b-row style="margin-top: 5px ">
      <b-col sm="9">Electricity kWh/Ton</b-col>
      <b-col sm="3">
        <b-form-input v-model="totalElectricityPerTon" readonly min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="margin-top: 5px ">
      <b-col sm="9">Water Gallons/Ton</b-col>
      <b-col sm="3">
        <b-form-input v-model="waterPerTon" readonly min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">

      <b-col sm="9">Water Gallons/Acre</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="waterPerAcre" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">

      <b-col sm="9">Co2e/Acre</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="totalCo2ePerTon" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "PerTonMetrics",
  props: {year: Number},
  data() {
    return {
      myYear: this.year,
    }
  },
  computed: {
    ...mapGetters(
        ['totalElectricityPerTon',
          'waterPerAcre',
          'waterPerTon',
          'totalCo2ePerTon']
    )
  }
}
</script>

<style scoped>

</style>
